module.exports = __webpack_public_path__ + "static/img/9.9866e9f.png";


//////////////////
// WEBPACK FOOTER
// ./src/public/image/12/4/1/9.png
// module id = 0mNi
// module chunks = 2